import { paginatedTransform } from 'src/services/skuit/utils'
import { BarcodedUnit, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class BarcodedUnits {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<BarcodedUnit>> => {
    const response = await this.api.get('/logistics/barcoded-units', config)
    return paginatedTransform(BarcodedUnit)(response.data)
  }
}
